import React from "react";
import TitleComponent from "../common/TitleComponent";
import { motion } from "framer-motion";

import FloatingImageSrc from "../../assets/images/Decorations/bg-leaf1.png";
import FloatingImageright from "../../assets/images/Decorations/bg-leaf2.png";

const schedule = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="55px"
    viewBox="0 -960 960 960"
    width="55px"
    fill="#a58000"
  >
    <path d="M186.67-80q-27 0-46.84-19.83Q120-119.67 120-146.67v-600q0-27 19.83-46.83 19.84-19.83 46.84-19.83h56.66V-880h70v66.67h333.34V-880h70v66.67h56.66q27 0 46.84 19.83Q840-773.67 840-746.67v600q0 27-19.83 46.84Q800.33-80 773.33-80H186.67Zm0-66.67h586.66v-420H186.67v420Zm0-486.66h586.66v-113.34H186.67v113.34Zm0 0v-113.34 113.34ZM480-400q-17 0-28.5-11.5T440-440q0-17 11.5-28.5T480-480q17 0 28.5 11.5T520-440q0 17-11.5 28.5T480-400Zm-160 0q-17 0-28.5-11.5T280-440q0-17 11.5-28.5T320-480q17 0 28.5 11.5T360-440q0 17-11.5 28.5T320-400Zm320 0q-17 0-28.5-11.5T600-440q0-17 11.5-28.5T640-480q17 0 28.5 11.5T680-440q0 17-11.5 28.5T640-400ZM480-240q-17 0-28.5-11.5T440-280q0-17 11.5-28.5T480-320q17 0 28.5 11.5T520-280q0 17-11.5 28.5T480-240Zm-160 0q-17 0-28.5-11.5T280-280q0-17 11.5-28.5T320-320q17 0 28.5 11.5T360-280q0 17-11.5 28.5T320-240Zm320 0q-17 0-28.5-11.5T600-280q0-17 11.5-28.5T640-320q17 0 28.5 11.5T680-280q0 17-11.5 28.5T640-240Z" />
  </svg>
);

const emoji_emotions = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="55px"
    viewBox="0 -960 960 960"
    width="55px"
    fill="#a58000"
  >
    <path d="M624-528.67q23.33 0 39.67-16.33Q680-561.33 680-584.67q0-23.33-16.33-39.66-16.34-16.34-39.67-16.34-23.33 0-39.67 16.34Q568-608 568-584.67q0 23.34 16.33 39.67 16.34 16.33 39.67 16.33Zm-288 0q23.33 0 39.67-16.33Q392-561.33 392-584.67q0-23.33-16.33-39.66-16.34-16.34-39.67-16.34-23.33 0-39.67 16.34Q280-608 280-584.67q0 23.34 16.33 39.67 16.34 16.33 39.67 16.33Zm144 268q66.67 0 122.17-36.5t80.5-98.16H277.33q25.67 61.66 80.84 98.16 55.16 36.5 121.83 36.5ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-400Zm0 333.33q139.58 0 236.46-96.87 96.87-96.88 96.87-236.46t-96.87-236.46Q619.58-813.33 480-813.33t-236.46 96.87Q146.67-619.58 146.67-480t96.87 236.46q96.88 96.87 236.46 96.87Z" />
  </svg>
);
const school = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="55px"
    viewBox="0 -960 960 960"
    width="55px"
    fill="#a58000"
  >
    <path d="M479.33-120 192.67-276.67v-240L40-600l439.33-240L920-600v318h-66.67v-280L766-516.67v240L479.33-120Zm0-316 301.34-164-301.34-162-300 162 300 164Zm0 240.33 220-120.66v-162.34L479.33-360l-220-120v163.67l220 120.66ZM480-436Zm-.67 79.33Zm0 0Z" />
  </svg>
);
const star = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="55px"
    viewBox="0 -960 960 960"
    width="55px"
    fill="#a58000"
  >
    <path d="M333.33-259 480-347l146.67 89-39-166.67 129-112-170-15L480-709l-66.67 156.33-170 15 129 112.34-39 166.33ZM233-120l65-281L80-590l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Zm247-353.33Z" />
  </svg>
);

const AchievementsContent = () => {
  const Achievements = [
    {
      id: 1,
      title: "Experience years",
      count: "2",
      icon: schedule,
    },
    {
      id: 2,
      title: "Happy Customers",
      count: "1k",
      icon: emoji_emotions,
    },
    {
      id: 3,
      title: "Awesome Instructors",
      count: "100",
      icon: school,
    },
    {
      id: 4,
      title: "Satisfaction",
      count: "100%",
      icon: star,
    },
  ];

  return (
    <>

<div className="mt-14">

      <TitleComponent
        Title={"Our recent achievements"}
        Subtitle={"Benefit from choosing the best."}
      />
      <div className="flex justify-start">
        <img
          src={FloatingImageSrc}
          alt="image 2"
          className="absolute -ml-20 z-10 object-cover  md:block hidden xl:h-72 xl:w-64 animate-float"
        />
      </div>

      <div className="flex justify-end ">
        <img
          src={FloatingImageright}
          alt="image 2"
          className="absolute -mr-7 z-10 object-cover  md:block hidden xl:h-auto xl:w-auto animate-float"
        />
      </div>

      <div className="flex flex-row flex-wrap gap-2 lg:gap-12 justify-center mt-10 mb-10">
        {Achievements.map((item, index) => {
          return (
            <motion.div
              key={item.id}
              className="flex flex-col gap-8 items-center px-5 py-9 w-64 h-64 shadow-lg rounded-sm bg-customBrass-90 "
              initial={{ opacity: 0, y: 50 }} // Start off invisible and below position
              animate={{ opacity: 1, y: 0 }} // Fade in and slide up
              transition={{
                delay: 0, // Staggered animation for each card
                duration: 0.6,
                ease: "linear",
              }}
              whileHover={{ scale: 1.1 }} // Slight zoom effect on hover
              whileTap={{ scale: 0.0 }} // Slight shrink effect on tap
            >
              <div className="flex items-center justify-center text-4xl text-customGreen">
                <div>{item.icon}</div>
              </div>
              <p className="text-center text-[4rem] nav_logo_AlegreyaSans-Light font-bold text-gray-800">
                {item.count}
              </p>
              <p className="text-center text-xl text_CormorantGaramond-Regular font-semibold text-gray-600">
                {item.title}
              </p>
            </motion.div>
          );
        })}
      </div>
      </div>
    </>
  );
};

export default AchievementsContent;
